import { bindRoutineToReduxForm, createRoutine } from 'redux-saga-routines';
import { CREATE_ADDRESS, UPDATE_ADDRESS } from 'types/addresses';
export const createAddressRoutine = createRoutine(CREATE_ADDRESS);
export const createAddressHandler = bindRoutineToReduxForm(createAddressRoutine);
export const updateAddressRoutine = createRoutine(UPDATE_ADDRESS);
export const updateAddressHandler = bindRoutineToReduxForm(updateAddressRoutine);
